module.exports = __webpack_public_path__ + "static/media/logo.fdf81dfa.svg";